import {
  Box,
  Button,
  Center,
  HStack,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PinInput,
  PinInputField,
  Text,
  Image,
} from '@chakra-ui/react'
import CustomButton from 'Components/CustomButton'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PospImages } from 'Assets/Posp'
import { useSelector } from 'react-redux'

interface IExamPassModal {
  isOpen: any
  score?: any
  total?: any
  certificateLink?: any
}
const ExamPassModal = ({ isOpen, score, total, certificateLink }: IExamPassModal) => {
  const navigate = useNavigate()
  const { journeyType } = useSelector((state: any) => state.user)

  const handleCertificateOpen = () => {
    const anchor = document.createElement('a')
    anchor.href = certificateLink
    anchor.target = '_blank'
    // anchor.download = 'generalInsuranceExamCertificate'
    anchor.click()
  }
  return (
    <Modal
      onClose={() => {
        console.log('cant close')
      }}
      size='lg'
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign='center' pt='16'>
          <Center>
            <Image src={PospImages.SucceedIcon} width='80px' />
          </Center>
        </ModalHeader>

        <ModalBody textAlign='center' my='6'>
          <Box>
            <Box>
              <Box>
                <Text fontWeight='bold' fontSize='31px'>
                  Congratulations!
                </Text>
              </Box>
            </Box>
            <Box mt='4%'>
              <Text fontSize='md'>
                You have successfully cleared your{' '}
                {journeyType === 'LIFE' ? 'Life' : 'General'} Insurance exam.
              </Text>
            </Box>
            {/* <Box mt='3%'>
              <Text fontSize='lg' fontWeight='semibold'>
                You have scored {score}/{total}.
              </Text>
            </Box> */}
            <Box>
              {/* <CustomButton
                buttonText='DOWNLOAD PASS CERTIFICATE'
                my='30px'
                fontWeight='medium'
                width='300px'
                handlerFunction={handleCertificateOpen}
                frameColor='#93C025'
                buttonVariant='outline'
              /> */}
              <CustomButton
                buttonText='BACK TO HOME'
                my='10px'
                handlerFunction={() => navigate('/registration-status')}
                fontWeight='medium'
                width='300px'
              />
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  )
}
export default ExamPassModal
